import { DateLike, getPreviousBusinessDay } from 'utils'
import { clientActionDevSignal } from './ClientAction'
import { SignalType } from './generated'

function getEffectiveInstant() {
  const now = new Date()
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 1))
}

export const createDevSignalAction = (
  signalType: SignalType,
  forUsers?: string[],
  forEntities?: string[],
  effectiveInstant?: DateLike,
  tradableType?: string
) => {
  return clientActionDevSignal({
    signalType,
    effectiveInstant: effectiveInstant ?? getEffectiveInstant(),
    sentInstant: new Date(),
    message: '',
    forUsers: forUsers || null,
    updateUserGroup: null,
    forEntities: forEntities || null,
    tradableType: tradableType || null
  })
}

export const DevSignalActions = {
  triggerSotw: createDevSignalAction(SignalType.SNAPSHOT_PUBLIC_EGRESS),
  triggerOrkDump: createDevSignalAction(SignalType.TRIGGER_ORDER_RECORD_KEEPING_DUMP),
  triggerRefinitivPriceRequest: createDevSignalAction(SignalType.TRIGGER_REFINITIV_PRICE_REQUEST),
  triggerRefinitivCollateralRequest: createDevSignalAction(SignalType.TRIGGER_REFINITIV_COLLATERAL_REQUEST),
  triggerRefinitivRicCodeRequest: createDevSignalAction(SignalType.TRIGGER_REFINITIV_COLLATERAL_RIC_LOAD),
  triggerRefinitivIssuerOrgRequest: createDevSignalAction(SignalType.TRIGGER_REFINITIV_ISSUER_ORG_REFRESH),
  triggerRefinitivNewFieldsRequest: createDevSignalAction(SignalType.UPDATE_COLLATERAL_FIELDS_REQUEST),
  triggerRefinitivCorpsRefreshRequest: createDevSignalAction(SignalType.TRIGGER_REFINITIV_COLLATERAL_CORPS_REFRESH),
  triggerTransactionReportingDump: createDevSignalAction(SignalType.TRIGGER_TRANSACTION_REPORTING_DUMP),
  triggerNegotiationExportDump: createDevSignalAction(SignalType.TRIGGER_NEGOTIATION_EXPORT_DUMP),
  triggerRefinitivImportReport: createDevSignalAction(SignalType.COLLATERAL_REFINITIV_REPORT_REQUEST_ADHOC),
  triggerDealExportDump: createDevSignalAction(SignalType.TRIGGER_DEAL_EXPORT_DUMP),
  triggerCalculateEndConsideration: createDevSignalAction(SignalType.RELOAD_AND_CALCULATE_END_CONSIDERATION),
  triggerReloadAndCompleteDeals: createDevSignalAction(SignalType.RELOAD_AND_COMPLETE_DEALS),
  triggerFailedExportsRetry: createDevSignalAction(SignalType.FAILED_EXPORTS_RETRY),
  triggerFailedExportsDelete: createDevSignalAction(SignalType.FAILED_EXPORTS_DELETE),
  triggerPurgeTradeData: createDevSignalAction(SignalType.PURGE_TRADE_DATA),
  triggerResetTestData: createDevSignalAction(SignalType.RESET_TEST_DATA),
  triggerFirdsReport: createDevSignalAction(SignalType.FIRDS_REPORT_REQUEST),
  triggerBondNoteUpdate: createDevSignalAction(SignalType.BONDS_NOTE_COLLATERAL_UPDATE_REQUEST),
  triggerIncrementIds: createDevSignalAction(SignalType.INCREMENT_IDS),
  triggerOktaUsersReport: createDevSignalAction(SignalType.OKTA_USERS_REPORT_REQUEST),
  triggerUpdateMortgageFactors: createDevSignalAction(SignalType.UPDATE_MORTGAGES_FACTORS_REQUEST),
  triggerCollateralMigration: createDevSignalAction(SignalType.MIGRATE_COLLATERAL_DETAILS),
  triggerCollateralClearTradeDate: createDevSignalAction(SignalType.TRIGGER_CLEAR_FIRST_TRADE_DATE),
  triggerGenerateScheduleReport: createDevSignalAction(SignalType.GENERATE_SCHEDULE_REPORT),
  triggerEodPurge: createDevSignalAction(SignalType.EOD_PURGE),
  setCurrentTradeDateToPreviousBusinessDay: createDevSignalAction(
    SignalType.SET_CURRENT_TRADE_DATE,
    undefined,
    undefined,
    getPreviousBusinessDay(new Date())
  ),
  setCurrentTradeDate: createDevSignalAction(SignalType.SET_CURRENT_TRADE_DATE),
  skipHolidays: createDevSignalAction,
  triggerRefreshDeals: createDevSignalAction
}
